import { render } from "./MailTableContainer.vue?vue&type=template&id=7a64019d&ts=true"
import script from "./MailTableContainer.vue?vue&type=script&lang=ts"
export * from "./MailTableContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__